export function mapEntity(item, type, objectTypes, publicationsForType) {
  /*
    mapEntity normalizza una entity proveniente dal backend
    (Strategy, CombinedStrategy, CombinedProduct, Screening, ecc.)
    aggiungendo:

    - UID:campo artificiale che creo per avere un identificatore univoco e stabile da usare come row id in tabulator.
          Il problema è che sia le strategie che i combined product possono avere id sovrapposti (es. strategy id 123 e combined product id 123), e tabulator si confonderebbe senza un id univoco.
          Quindi creo UID concatenando il tipo (strategy, combinedStrategy, combinedProduct) con l’id originale, garantendo così unicità assoluta. 
    - pubSubType: tipo tradotto lato UI
    - publicationId: collegamento alla pubblicazione (se esiste)
  */

  const clone = { ...item };

  clone.UID = `${type}_${item.id}`;

  clone.pubSubType = objectTypes[item.type];

  clone.publicationId = publicationsForType?.[item.id]?.publicationId ?? null;

  return clone;
}

export const screeningTagsPlaceholder = [{
  id: "group-screening",
  name: "Rules",
  allName: "All Types",
  type: "multiple",
  default: ["test1"],
  display: ["table", "edit", "directory"],
  filters: [
    {
      id: "test1",
      name: "test tag for screening - 1",
      type: "value",
    },
    {
      id: "test2",
      name: "test tag for screening - 2",
      type: "value",
    },
  ],
}];
